<template>
  <div id="pest-analyse" style="overflow:hidden;">
    <div class="pestAnalyse-data">
      <div class="pestAnalyse-data-head">
        <div class="pestAnalyse-head-title">
          <span class="pestAnalyse-head-title-container">虫情图片分析</span>
        </div>

        <div class="pestAnalyse-head-select">
          <div class="pestAnalyse-select-device">
            <el-select @change="pestDeviceChange($event)" v-model="defaultPestDevice" filterable>
              <el-option :key="item.deviceAddr" :label="item.deviceName" :value="item.deviceAddr" v-for="item in pestDeviceList"></el-option>
            </el-select>
          </div>

          <div class="pestAnalyse-select-time" >
            <el-date-picker @change="pestSelectTime" v-model="defaultPestTime" unlink-panels type="datetimerange" :picker-options="pestPickerOptions" align="right"
                            end-placeholder="结束日期" key="time" range-separator="至" start-placeholder="开始日期">
            </el-date-picker>
          </div>

          <div class="pestAnalyse-select-btn">
            <el-button type="primary" @click="pestQueryData()">查询</el-button>
          </div>
        </div>
      </div>
      <div class="pestAnalyse-data-content">
<!--        <div v-for="(row, index) in sliceList(pestPicList, 2)":key="index" style=" width: 100%;height: 46%;">-->
        <div v-for="(row, index) in sliceList(pestPicList.slice((pestCurrentPage-1)*4,pestCurrentPage*4), 2)":key="index" style=" width: 100%;height: 45%;">
          <div class="pestAnalyse-data-body" >
            <div v-for="(item, i) in row"  class="pestAnalyse-data-bodyContainer">
              <div class="pestAnalyse-data-body-img">
                <div class="pestAnalyse-data-body-imgContainer">
                  <img :src="item.imagesUrl" class="pestAnalyse-data-body-leftImg" referrerpolicy="no-referrer">
                </div>
                <div class="pestAnalyse-data-body-imgContainer">
                  <img :src="item.analyseCoordUrl" class="pestAnalyse-data-body-rightImg" referrerpolicy="no-referrer">
                </div>

              </div>
              <div class="pestAnalyse-data-body-container">
                <div class="pestAnalyse-data-body-leftContainer">
                  <div class="pestAnalyse-leftContainer-top">
                    <div class="pestAnalyse-leftContainer-name">
                      <span class="pestAnalyse-leftContainer-nameValue">记录表id：{{item.recordId}}</span>
                    </div>
                    <div class="pestAnalyse-leftContainer-name" >
                      <span class="pestAnalyse-leftContainer-nameValue">设备地址：{{item.deviceAddr}}</span>
                    </div>
                  </div>

                  <div class="pestAnalyse-leftContainer-top">
                    <div class="pestAnalyse-leftContainer-name">
                      <span class="pestAnalyse-leftContainer-nameValue">采样时间<br/>{{item.createTime}}</span>
                    </div>
                    <div class="pestAnalyse-leftContainer-name">
                      <span class="pestAnalyse-leftContainer-nameValue">分析时间<br/>{{item.verifyTime}}</span>
                    </div>
                  </div>

                  <div class="pestAnalyse-leftContainer-top">
                    <div class="pestAnalyse-leftContainer-name">
                      <span class="pestAnalyse-leftContainer-nameValue">分析员：{{item.analyst}}</span>
                    </div>
                    <div class="pestAnalyse-leftContainer-name">
                      <span class="pestAnalyse-leftContainer-nameValue">AI分析结果：{{item.wormDataAIDO}}</span>
                    </div>
                  </div>

                  <div class="pestAnalyse-leftContainer-remark">
                    <span> 备注：{{item.remark}}</span>
                  </div>
                </div>
                <div class="pestAnalyse-data-body-rightContainer">
                  <span>害虫：{{item.analyseData}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <el-pagination @current-change="pestCurrentChange" :current-page="pestCurrentPage" style="text-align: center; margin-top: 1%"
                       :page-size="4" layout="total, prev, pager, next, jumper" :total="pestPicList.length">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from "moment";
  import {getWormDataList} from "../../until/api/SporePest";
  export default {
    name: 'PestAnalyseData',
    components: {},
    computed: {
      sliceList() {
        return function (data,count) {
          if(data != undefined) {
            let index = 0;
            let arrTemp = [];
            for(let i = 0; i < data.length; i++) {
              index = parseInt(i / count);
              if(arrTemp.length <= index) {
                arrTemp.push([])
              }
              arrTemp[index].push(data[i]);
            }
            return arrTemp;
          }
        }
      }
    },
    data() {
      return {
        pestDeviceList:[],
        defaultPestDevice:'',
        defaultPestTime: [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm"), moment().format("YYYY-MM-DD HH:mm")],
        pestPickerOptions: {
          shortcuts: [{
            text: '最近一天',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        beginTime: '',
        endTime: '',
        pestPicList: [],
        pestCurrentPage: 1,
      }
    },

    mounted() {
      this.pestHistoryList(); //获取虫情设备列表
      this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"); //初期化开始时间
      this.endTime = moment().format("YYYY-MM-DD HH:mm:ss"); //初期化结束时间
    },
    methods: {
      /**
       * 获取虫情设备列表
       */
      pestHistoryList() {
        let that = this;
        this.$SporeSoilCommon.getSpDeviceList(function (deviceList) { //获取所有虫情孢子设备
          if(deviceList.code != 2000) {
            for(let i = 0; i < deviceList.data.length; i++) {
              if(deviceList.data[i].deviceType.indexOf('worm') > -1) { //筛选出虫情设备
                let pestJson = {};
                pestJson.deviceAddr = deviceList.data[i].deviceAddr;
                pestJson.deviceName = deviceList.data[i].deviceName;
                that.pestDeviceList.push(pestJson);
              }
            }
            if(that.pestDeviceList.length > 0) {
              that.defaultPestDevice = that.pestDeviceList[0].deviceAddr; //默认虫情设备
              that.pestAnalyseData(); //获取图片分析数据
            }
          }
        })
      },

      /**
       * 切换设备
       * @param event
       */
      pestDeviceChange(event) {
        this.defaultPestDevice = event;
        this.pestPicList = []; //清空数据列表
      },

      /**
       *获取选择的时间
       * @param val
       */
      pestSelectTime(val) {
        if(val === null) {//清空日期
          this.defaultPestTime = [moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"), moment().format("YYYY-MM-DD HH:mm:ss")]; //默认时间
          this.beginTime = moment().subtract(1, "days").format("YYYY-MM-DD HH:mm:ss"); //默认开始时间
          this.endTime = moment().format("YYYY-MM-DD HH:mm:ss"); //默认结束时间
        } else {//非清空数据
          this.beginTime = moment(new Date(val[0]).getTime()).format("YYYY-MM-DD HH:mm:ss"); //开始时间
          this.endTime = moment(new Date(val[1]).getTime()).format("YYYY-MM-DD HH:mm:ss");//结束时间
        }
      },

      /**
       * 查询数据
       */
      pestQueryData() {
        if(this.defaultPestDevice != '') {
          this.pestAnalyseData();//获取图片分析数据
        }
      },

      /**
       * 获取图片分析数据
       */
      pestAnalyseData() {
        this.pestCurrentPage = 1;
        this.pestPicList = [];
        getWormDataList(this.defaultPestDevice, this.beginTime, this.endTime).then(response => {
          if( response.data.code != 2000 && response.data.data.rows.length > 0) {
            for(let i = 0; i < response.data.data.rows.length; i++) {
              let pestJson = {};
              pestJson.recordId = response.data.data.rows[i].recordId; //记录表id
              pestJson.deviceAddr = response.data.data.rows[i].deviceAddr; //设备地址
              pestJson.createTime = response.data.data.rows[i].createTime; //创建时间
              pestJson.verifyTime = response.data.data.rows[i].verifyTime == '2000-01-01 08:00:00' ? '-' : response.data.data.rows[i].verifyTime; //分析时间
              pestJson.analyst = response.data.data.rows[i].analyst == null ? '-': response.data.data.rows[i].analyst; //分析员
              pestJson.wormDataAIDO = response.data.data.rows[i].wormDataAIDO == null ? '-' : response.data.data.rows[i].wormDataAIDO; //AI分析结果
              pestJson.remark = response.data.data.rows[i].remark == null ? '-' : response.data.data.rows[i].remark; //备注
              pestJson.analyseData = response.data.data.rows[i].analyseData == '[]' ? '-' : this.getAnalyseData(response.data.data.rows[i].analyseData); //害虫种类及数量
              pestJson.imagesUrl = response.data.data.rows[i].imagesUrl; //图片地址
              pestJson.analyseCoordUrl = response.data.data.rows[i].analyseCoordUrl; //分析后的图片地址
              this.pestPicList.push(pestJson);
            }
          } else {
            this.$message({
              showClose: true,
              type: 'warning',
              message: '所选的时间段内未查询出数据'
            })
          }

        }).catch(error => {
          console.log("error", error);
        })
      },

      /**
       * 获取害虫种类及数量
       * @param analyseData
       */
      getAnalyseData(analyseData) {
        let analyseJson = JSON.parse(analyseData);
        let analyseStr = '';
        if(analyseJson != null) {
          for(let i = 0; i < analyseJson.length; i++){
            analyseStr += i == analyseJson.length - 1 ?  analyseJson[i].name + ':' + analyseJson[i].num : analyseJson[i].name + ':' + analyseJson[i].num + ";";
          }
        }
        return analyseStr;
      },

      /**
       * 更改页数
       * @param currentPage
       */
      pestCurrentChange(currentPage) {
        this.pestCurrentPage = currentPage;
      },
    }
  }
</script>

<style lang="less">
  @import "../less/PestAnalyseData";
</style>

<style>
  .pestAnalyse-data-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/PestAnalyseData.vue